module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag26_1277AT.b044985e.jpg";